/* The minimum number of adult attendants permitted per trip. */
export const MIN_NUM_ADULT_ATTENDANTS = 0;

/* The maximum number of adult attendants permitted per trip. */
export const MAX_NUM_ADULT_ATTENDANTS = 10;

/* Dropdown options for number of adult attendants. */
export const NUM_ADULT_ATTENDANT_OPTIONS = Object.freeze(
  Array.from(
    { length: MAX_NUM_ADULT_ATTENDANTS - MIN_NUM_ADULT_ATTENDANTS + 1 },
    (_, i) => ({
      label: i + MIN_NUM_ADULT_ATTENDANTS,
      value: i + MIN_NUM_ADULT_ATTENDANTS,
    }),
  ),
);

/* The minimum number of child attendants permitted per trip. */
export const MIN_NUM_CHILD_ATTENDANTS = 0;

/* The maximum number of child attendants permitted per trip. */
export const MAX_NUM_CHILD_ATTENDANTS = 10;

/* Dropdown options for number of child attendants. */
export const NUM_CHILD_ATTENDANT_OPTIONS = Object.freeze(
  Array.from(
    { length: MAX_NUM_CHILD_ATTENDANTS - MIN_NUM_CHILD_ATTENDANTS + 1 },
    (_, i) => ({
      label: i + MIN_NUM_CHILD_ATTENDANTS,
      value: i + MIN_NUM_CHILD_ATTENDANTS,
    }),
  ),
);

/* The minimum number of child seats permitted per trip. */
export const MIN_NUM_CHILD_SEATS = 0;

/* The maximum number of child seats permitted per trip. */
export const MAX_NUM_CHILD_SEATS = 10;

/* Dropdown options for number of child seats. */
export const NUM_CHILD_SEAT_OPTIONS = Object.freeze(
  Array.from(
    { length: MAX_NUM_CHILD_SEATS - MIN_NUM_CHILD_SEATS + 1 },
    (_, i) => ({
      label: i + MIN_NUM_CHILD_SEATS,
      value: i + MIN_NUM_CHILD_SEATS,
    }),
  ),
);
